import type { ReactNode } from "react";

interface AppendixIntroProps {
  eyebrow: string;
  title: string;
  body: string;
  noteTitle: string;
  note: string;
  actions?: ReactNode;
}

export function AppendixIntro({
  eyebrow,
  title,
  body,
  noteTitle,
  note,
  actions
}: AppendixIntroProps) {
  return (
    <section
      style={{
        borderRadius: "24px",
        padding: "24px",
        background: "linear-gradient(180deg, rgba(10, 15, 27, 0.82), rgba(7, 11, 21, 0.74))",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 18px 40px rgba(3, 8, 20, 0.18)"
      }}
    >
      <div
        style={{
          display: "grid",
          gap: "18px",
          gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 260px), 1fr))",
          alignItems: "start"
        }}
      >
        <div className="stack-sm">
          <span className="card-eyebrow">{eyebrow}</span>
          <h2
            style={{
              margin: 0,
              fontSize: "clamp(1.85rem, 3vw, 2.7rem)",
              lineHeight: 1,
              letterSpacing: "-0.04em",
              color: "#f4f8ff",
              maxWidth: "14ch"
            }}
          >
            {title}
          </h2>
          <p style={{ margin: 0, color: "rgba(223, 232, 246, 0.78)", lineHeight: 1.6, maxWidth: "62ch" }}>{body}</p>
          {actions ? <div className="row-wrap gap-sm">{actions}</div> : null}
        </div>
        <div
          style={{
            borderRadius: "18px",
            padding: "16px",
            background: "rgba(255,255,255,0.03)",
            border: "1px solid rgba(255,255,255,0.08)"
          }}
        >
          <div
            style={{
              fontSize: "0.72rem",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "rgba(198,211,234,0.62)"
            }}
          >
            {noteTitle}
          </div>
          <div style={{ marginTop: "10px", color: "rgba(232, 239, 250, 0.86)", lineHeight: 1.55 }}>{note}</div>
        </div>
      </div>
    </section>
  );
}
